export var AssignmentHandlerEscalationType;
(function (AssignmentHandlerEscalationType) {
    AssignmentHandlerEscalationType[AssignmentHandlerEscalationType["None"] = 0] = "None";
    AssignmentHandlerEscalationType[AssignmentHandlerEscalationType["Current"] = 1] = "Current";
    AssignmentHandlerEscalationType[AssignmentHandlerEscalationType["Warn"] = 2] = "Warn";
    AssignmentHandlerEscalationType[AssignmentHandlerEscalationType["Late"] = 3] = "Late";
    AssignmentHandlerEscalationType[AssignmentHandlerEscalationType["Expired"] = 4] = "Expired";
    AssignmentHandlerEscalationType[AssignmentHandlerEscalationType["Escalate"] = 5] = "Escalate";
    AssignmentHandlerEscalationType[AssignmentHandlerEscalationType["Check"] = 6] = "Check";
})(AssignmentHandlerEscalationType || (AssignmentHandlerEscalationType = {}));
;
